import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { AnimatePresence, motion } from 'framer-motion';
import styled from 'styled-components';
import { ease } from '../../utils/easing';
import { LayoutContext } from '../organisms/layoutProvider';
import { useWindowSize } from '../../hooks/useWindowSize';
import { media } from '../../utils/media-queries';

const textWrapper = {
  open: {
    opacity: 1,
    transition: { ease: ease.smoothIn, duration: 0.2 },
  },
  close: {
    opacity: 0,
    transition: { ease: ease.smoothIn, duration: 0.2 },
  },
};

const text = {
  hidden: { opacity: 0, transition: { ease: ease.smoothOut, duration: 0.2 } },
  show: {
    opacity: 1,
    transition: {
      ease: ease.smoothOut,
      duration: 0.5,
      delay: 0.2,
    },
  },
};

const CollapsedNav = ({ active, initialClosed = true, children, onClick }) => {
  const { theme } = useContext(LayoutContext);

  useEffect(() => {
    if (theme === 'light') {
      document.documentElement.style.setProperty('--text-color', '#000');
      document.documentElement.style.setProperty('--bg-color', '#fff');
      document.documentElement.style.setProperty('--font-1', 'Jannon');
      document.documentElement.style.setProperty('--font-2', 'Favorit');
    }
    if (theme === 'dark') {
      document.documentElement.style.setProperty('--text-color', '#fff');
      document.documentElement.style.setProperty('--bg-color', '#000');
      document.documentElement.style.setProperty('--font-1', 'Favorit');
      document.documentElement.style.setProperty('--font-2', 'Jannon');
    }
  }, [theme]);

  return (
    <AnimatePresence>
      {active && (
        <StyledNav
          className="nav spacing-inner"
          style={{ overflow: 'hidden' }}
          variants={textWrapper}
          initial={initialClosed ? 'close' : 'open'}
          animate={active ? 'open' : 'close'}
          exit={initialClosed ? 'close' : 'open'}
          onClick={onClick}
        >
          <motion.ul
            key="text"
            className="wrapper"
            variants={text}
            initial={initialClosed ? 'hidden' : 'show'}
            animate={active ? 'show' : 'hidden'}
            exit={initialClosed ? 'hidden' : 'show'}
          >
            {children}
          </motion.ul>
        </StyledNav>
      )}
    </AnimatePresence>
  );
};

const StyledNav = styled(motion.nav)``;

CollapsedNav.propTypes = {
  active: PropTypes.bool,
  initialClosed: PropTypes.bool,
  children: PropTypes.node,
  onClick: PropTypes.func,
};

export default CollapsedNav;
